module.exports = __webpack_public_path__ + "media/images/24_hours-24ff9878.svg";